import { useEffect } from "react";
import { useState } from "react";
import CommunityFooter from "../components/community/footer";
import HeaderSearch from "../components/community/headerSearch";
import { hideLoader, showLoader } from "../components/loader";
import PageHeader from "../components/page-header";
import SideBar from "../components/side-bar";
import { audiencePosts as getManageBillings } from "../services/postRequests/audience";
import { apiUrl } from "../utils/url";
import { audiencePosts as mangageStripePost } from "../services/postRequests/audience";
import { audiencePosts as manageSubscriptionPost } from "../services/postRequests/audience";
import "../assets/css/manage-billings.css"
import Skeleton from "react-loading-skeleton";
import unlinkPro from "../assets/img/unlink-pro-icon.svg";
import addPro from "../assets/img/add-pro-icon.svg";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

let params = [];
const ManageBillings = () => {
    const [filter, setfilter] = useState({ page: 1, search: null, project: localStorage.slug });
    const [manageProjects, setmanageProjects] = useState([]);
    const [loading, setloading] = useState(true)
    const history = useHistory();
    const callManageProjects = () => {
        setloading(false)
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        const api = apiUrl + `/project/manage?` + params?.join("&");
        const setOptions = {
            method: "GET",
            headers: myHeaders
        };
        getManageBillings(api, hideLoader, setOptions).then((response) => {
            if (response) {
                setmanageProjects(response)
                setloading(false)
            }
        })
    }

    useEffect(() => {
        params = [];
        for (const key in filter) {
            if (Object.hasOwnProperty.call(filter, key))
                if (filter[key]) params.push(`${[key]}=${filter[key]}`)
        };
        if (filter?.page) callManageProjects()

    }, [filter]);

    const mangageStripe = (e) => {
        showLoader()
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`)
        const formdata = new FormData()
        formdata.append("project", e.target.dataset.value)
        const api = apiUrl + `/manage-subscription`;
        const setOptions = {
            method: "POST",
            body: formdata,
            headers: myHeaders
        }
        mangageStripePost(api, hideLoader, setOptions).then((response) => {
            if (response) {
                location.href = response?.url
                showLoader()
            }
        })
    }
    const manageSubscription = (e) => {
        showLoader()
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`)
        const formdata = new FormData()
        formdata.append("tolt_referral", window.tolt_referral??'');
        formdata.append("project", e.target.dataset.value);
        formdata.append("plan_type", "pro");
        const api = apiUrl + `/project/link-unlink-pro/`+(e.target.dataset.value);
        const setOptions = {
            method: "POST",
            headers: myHeaders
        }
        manageSubscriptionPost(api, hideLoader, setOptions).then((response) => {
            if (response) {
                
// console.log(response);
                // hideLoader();
                showLoader()
                if(response?.url){
                    history.push(response?.url);
                    // localStorage.temp_slug = e.target.dataset.value
                    // localStorage.last_activity=location.pathname
                    // location.href = response.url
                }
                else{
                    callManageProjects();
                }
            }
        })
    }

    return (
        // <div id="wrapper">
        //     <PageHeader from="manage-billings" />
        //     <div class="community-main manage-billing-main">
        //         <SideBar from="manage-billings" />

                <section class="container h-100" style={{overflowY:"auto"}}>
                    <div className="container settings-section" style={{paddingLeft: "30px",paddingRight: "30px",paddingBottom: "22px"}}>
                        <h1 className="settings-section-heading">Billing</h1>

                    <div class="section-main w-100">
                                {
                                    loading ?
                                        <tbody>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">
                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">
                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">
                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">
                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">
                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">
                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">
                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">
                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">
                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">
                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                            </tr>
                                        </tbody> :
                                        <div className="">
                                            {manageProjects?.projects?.length > 0 && (
                                                manageProjects?.projects?.map((val, index) => (
                                                    <div key={index} className="d-flex justify-content-between my-2 billings-data-div">
                                                        <div className="d-flex">
                                                            <p class="mb-0 d-inline-flex align-items-center justify-content-start" style={{gap:"10px"}}>

                                                                <div className="project-small-details d-flex align-items-start justify-content-center flex-column ps-2">
                                                                    <div className="project-small-user-pp">
                                                                        <img class="me-2 ms-2" src={val?.profile_picture} width="30px" alt="" />
                                                                        <span class="manage-projects-text ">{val?.title}</span>
                                                                    </div>
                                                                </div>
                                                                    <div class={`${val?.pro !== 1 || val?.plan_type == 'basic' ? "project-types bg-f3f3f3 text-capitalize" : "sidebar-plantype"}`}>
                                                                        {val?.plan_type !== 'basic' && 
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none">
                                                                                <path d="M3.025 5.45L3.37801 6.15601C3.49748 6.39495 3.55721 6.51442 3.63701 6.61795C3.70783 6.70982 3.79018 6.79217 3.88205 6.86299C3.98558 6.94279 4.10505 7.00252 4.34399 7.12199L5.05 7.475L4.34399 7.82801C4.10505 7.94748 3.98558 8.00721 3.88205 8.08701C3.79018 8.15783 3.70783 8.24018 3.63701 8.33205C3.55721 8.43558 3.49748 8.55505 3.37801 8.79399L3.025 9.5L2.67199 8.79399C2.55252 8.55505 2.49279 8.43558 2.41299 8.33205C2.34217 8.24018 2.25982 8.15783 2.16795 8.08701C2.06442 8.00721 1.94495 7.94748 1.70601 7.82801L1 7.475L1.70601 7.12199C1.94495 7.00252 2.06442 6.94279 2.16795 6.86299C2.25982 6.79217 2.34217 6.70982 2.41299 6.61795C2.49279 6.51442 2.55252 6.39495 2.67199 6.15601L3.025 5.45Z" stroke="#213B7C" stroke-linecap="round" stroke-linejoin="round" />
                                                                                <path d="M6.85 0.5L7.38038 1.87899C7.50729 2.20894 7.57074 2.37392 7.66941 2.51269C7.75686 2.63568 7.86432 2.74314 7.98731 2.83059C8.12608 2.92926 8.29106 2.99271 8.62101 3.11962L10 3.65L8.62101 4.18038C8.29106 4.30729 8.12608 4.37074 7.98731 4.46941C7.86432 4.55686 7.75686 4.66432 7.66941 4.78731C7.57074 4.92608 7.50729 5.09106 7.38038 5.42101L6.85 6.8L6.31962 5.42101C6.19271 5.09106 6.12926 4.92608 6.03059 4.78731C5.94314 4.66432 5.83568 4.55686 5.71269 4.46941C5.57392 4.37074 5.40894 4.30729 5.07899 4.18038L3.7 3.65L5.07899 3.11962C5.40894 2.99271 5.57392 2.92926 5.71269 2.83059C5.83568 2.74314 5.94314 2.63568 6.03059 2.51269C6.12926 2.37392 6.19271 2.20894 6.31962 1.87899L6.85 0.5Z" stroke="#213B7C" stroke-linecap="round" stroke-linejoin="round" />
                                                                            </svg>
                                                                        }
                                                                        {val?.plan_type == 'basic' ? 'Free' : val?.plan_type}
                                                                    </div>
                                                            </p>
                                                        </div>
                                                        {/* <td class="d-md-table-cell d-none">{setDateFormat(val?.created_at)}</td> */}

                                                            <span class="d-flex align-items-center">
                                                                {val?.pro == 1 ? <p class="manage-btn mb-1 mt-1 badge badge-subscribed cursor-pointer" data-value={val?.slug} onClick={val?.pro == 1 && val?.manage_stripe == 1 ? mangageStripe : manageSubscription}>

                                                                    {/* <img src={unlinkPro} alt="" srcset="" data-value={val?.slug}/> */}
                                                                    <span  data-value={val?.slug}>{(val?.pro == 1 && val?.manage_stripe == 1 )?"Manage Subscription ":`Unlink ${val?.plan_type == "ultra" ? "Ultra":val?.plan_type == 'partner'?'Partner':'Pro'}`}</span>

                                                                </p>
                                                                    : <p class="manage-btn mb-1 me-2 badge me-2 badge-customer cursor-pointer" data-value={val?.slug} onClick={manageSubscription}>

                                                                        {/* <img src={addPro} alt="" srcset="" data-value={val?.slug}/> */}
                                                                        <span  data-value={val?.slug}>Upgrade</span>
                                                                    </p>
                                                                }
                                                            </span>
                                                        {/* <td>
                                                            {(val?.pro == 1 && val?.manage_stripe == 1 ) && (
                                                                <button className="btn manage-billings me-3" data-value={val?.slug} onClick={mangageStripe}>Manage in Stripe</button>)
                                                            }
                                                        </td> */}
                                                        {/* <td class="d-md-table-cell d-none">{val?.opens}</td> */}

                                                    </div>
                                                )))}
                                        </div>
                                }
                                
                        {Math.abs(manageProjects?.available_pros) > 0 &&
                        <>
                         {/* {manageProjects?.projects && manageProjects?.projects.some(project => project.manage_stripe === 0 ) && (
                         <div class="section-header">
                             <h3 class="mb-0">Pro Projects Available</h3>
                         </div>
                         )} */}
                        {manageProjects?.projects && manageProjects?.projects.some(project => project.manage_stripe === 0) && (
                        <div className="mx-4 d-flex mt-4 mb-4 row">
                            <div className="col-6">
                            <div className="projects-availabiltiy-section-div ">
                                <div><b class="mb-0">Available Pro Projects</b><p>{manageProjects?.available_pros}</p></div>
                            </div>
                            </div>
                            <div className="col-6">
                            <div className="projects-availabiltiy-section-div ">
                                <div><b class="mb-0">Total Pro Projects</b><p>{manageProjects?.total_pros}</p></div></div>
                            </div>
                        </div>
                        )}
                        </>
                        }
                        {/* <div class="section-footer d-flex align-items-center justify-content-between">
                            <CommunityFooter filter={filter} setfilter={setfilter} total={manageProjects?.paginated?.total} last_page={manageProjects?.paginated?.last_page} />
                        </div> */}
                    </div>

                    </div>
                </section>
        //     </div>

        // </div>
    )
}
export default ManageBillings;